<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C8,0,10.5,5.3,10.5,5.3C10.5,5.3,16,6.1,16,6.1C16,6.1,12,10.2,12,10.2C12,10.2,12.9,16,12.9,16C12.9,16,8,13.3,8,13.3C8,13.3,3.1,16,3.1,16C3.1,16,4,10.2,4,10.2C4,10.2,0,6.1,0,6.1C0,6.1,5.5,5.3,5.5,5.3C5.5,5.3,8,0,8,0C8,0,8,0,8,0Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Star',
} as DefineComponent
</script>
